import { useState } from "react"
import cc from "classcat"
import kebabCase from "lodash.kebabcase"
import useTranslations from "hooks/useTranslations"
import Question from "components/atoms/common/Question"

const Heading = ({ className, title }) => (
  <h2
    className={cc([
      "font- extrabold m-0 mb-6 max-w-lg whitespace-pre-line text-4xl tracking-tight text-neutral-800 sm:text-5xl",
      className,
    ])}
  >
    {title}
  </h2>
)

const FAQ = ({ className = "", pairs, Image }) => {
  const [openedQuestions, setOpenedQuestion] = useState({})
  const {
    helpdeskLink,
    faqTitle,
    faqSubtitle1,
    faqSubtitleLink,
    faqSubtitle2,
  } = useTranslations()
  return (
    <div
      className={cc([
        "relative py-16 lg:py-24",
        className.includes("bg-") ? className : "bg-white",
      ])}
    >
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Heading title={faqTitle} className="lg:hidden" />
        <div className="grid grid-cols-1 items-start gap-y-8 lg:grid-cols-2">
          <div>
            <div>
              <Heading title={faqTitle} className="hidden lg:block" />
              <p className="max-w-lg text-base leading-6 text-zinc-800">
                {faqSubtitle1}
                <a
                  className="ml-1 underline"
                  href={helpdeskLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {faqSubtitleLink}
                </a>
                {faqSubtitle2}
              </p>
            </div>
            <dl className="m-0 list-none divide-y-2 divide-kkm-green border-b-2 border-t-2 border-kkm-green">
              {pairs.map((pair) => (
                <Question
                  key={kebabCase(`${pair.id}_${pair.question}`)}
                  {...pair}
                  active={openedQuestions[pair.id]}
                  onClick={() => {
                    setOpenedQuestion((oldState) => ({
                      ...oldState,
                      [pair.id]: !oldState[pair.id],
                    }))
                  }}
                />
              ))}
            </dl>
          </div>
          <div className="order-first -mx-4 pl-2 lg:order-last lg:mx-0 lg:pl-0">
            <div className="lg:absolute lg:inset-y-20 lg:right-0 lg:w-1/2 lg:pl-10">
              <div className="relative z-[1] flex max-h-[20rem] overflow-hidden rounded-l-full lg:min-h-[35rem] xl:min-h-[33rem]">
                <Image className="mb-px w-full border" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default FAQ
